"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Maßstabs-Auswahlliste.
 *
 * @class
 * @extents gc.gis.widget.GCWidget
 * @memberof gc.gis.widget
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.map.GCMapScale[]} [options.scales=[]] Liste der Maßstäbe
 * @param {string} [options.direction='down'] Aufklapprichtung 'down' oder 'up'
 * @param {string} [options.inputClassName] zusätzliche CSS-Klasse(n), die am Input-Element gesetzt wird/werden
 * @param {function} [options.change] Funktion, die bei Änderung des Maßstabs aufgerufen werden soll
 * @param {string} [options.userdefinedScale=true] Flag um freie Eigabe des Maßstabs durch Nutzer zu erlauben
 * @param {Number} [options.minScale] minimaler Maßstab, den der Nutzer eingeben kann
 * @param {Number} [options.maxScale] maximaler Maßstab, den der Nutzer eingeben kann
 */
gc.gis.widget.GCScaleSelector = function(options)
{
	gc.gis.widget.GCWidget.call(this, options);

	this._scales = options.scales || [];
	this._direction = options.direction || 'down';
	this._inputClassName = options.inputClassName;
	this._change = options.change;
	this._userdefinedScale = options.userdefinedScale !== false;
	this.setScaleBounds(options.minScale, options.maxScale);
	this._currentScale = -1;

	this._render();
	this._initEvents();

	this.setScales(this._scales);
};
gc.gis.widget.GCScaleSelector.prototype = Object.create(gc.gis.widget.GCWidget.prototype);

/**
 * @inheritdoc
 */
gc.gis.widget.GCScaleSelector.prototype._render = function()
{
	// Container
	if(!this.element)
	{
		// Prefix-Text "1:"
		this._element_scale_text = jQuery('<span>', {
			'class': 'input-group-addon gc-scale-prefix',
			text: '1 :'
		});

		// Aufklapp-Button
		this._element_drop_btn = jQuery('<button>', {
			'type': 'button',                               // ohne type-Attribut, öffnet sich Dropdown, wenn Enter im Eingabefeld gedrückt wird
			'class': 'btn btn-default dropdown-toggle',
			'aria-expanded': false,
			'aria-haspopup': true,
			'data-toggle': 'dropdown',
			'html': '&nbsp;<span class="caret"></span>'
		});

		// Liste und Eingabefeld
		this._element_ul = jQuery('<ul>', {
			'class': 'dropdown-menu dropdown-menu-right'
		});
		this._element_input = jQuery('<input>', {
			title: (this._userdefinedScale ? 'Maßstab ändern' : 'Maßstab auswählen'),
			'class': 'form-control gc-scale-input gc-control-input'
				+ (this._inputClassName ? ' ' + this._inputClassName : ''),
			type: 'text',
			readonly: !this._userdefinedScale
		});
		this._element_input.attr('size', 7);
		gc.gis.iface.ui.tooltip(this._element_input);

		const element_drop_group = jQuery('<span>', {
			'class': 'input-group-btn drop' + this._direction
		});
		element_drop_group.append(this._element_drop_btn).append(this._element_ul);

		this.element = jQuery('<span>', {
			'class': 'input-group'
		});

		this.element.append(this._element_scale_text).append(this._element_input).append(element_drop_group);
	}

	return this.element;
};

/**
 * Initialisiert die Events des Steuerelements.
 * @private
 */
gc.gis.widget.GCScaleSelector.prototype._initEvents = function()
{
	const self = this;
	this._element_input.on('click', function(evt) {
		evt.preventDefault();
	});

	const doChange = function (value) {
		const oldScale = self.getScale();
		self.setScale(value);

		if (oldScale !== self.getScale() && typeof self._change === 'function')
		{
			self._change.call(self, self.getScale());
		}
	};

	// der IE löst beim Drücken von Enter kein Change-Event aus, daher über keyup-Event
	// this._element_input.on('change', function(evt) {
	// 	self._doChangeScale(this.value);
	// });

	this._element_input.on('keyup', function(evt) {
		if (13 === evt.keyCode)
		{
			self._doChangeScale(this.value);
		}
	});

	this._element_input.on('focusout', function(evt) {
		// evt.preventDefault();
		// evt.stopPropagation();
		self._doChangeScale(this.value);
	});

	this._element_input.on('focus', function() {
		self._element_input.val(self._currentScale);    // Trennzeichen entfernen
		this.select();
	});

	this._element_input.on('input', function() {
		const val = self._element_input.val();
		self._setValid(val === '' || self._isValid(val));
	});
};

/**
 * Liefert das Element, für die Nutzereingabe. Das gesamte Element, welches durch getElement() repräsentiert wird
 * umfasst als Container mehrere HTML-Elemente.
 * @return {jQuery}
 */
gc.gis.widget.GCScaleSelector.prototype.getElementInput = function()
{
	return this._element_input;
};

/**
 * Setzt die auswählbaren Maßstäbe
 *
 * @param {gc.gis.map.GCMapScale[]} scales Liste der Maßstäbe
 */
gc.gis.widget.GCScaleSelector.prototype.setScales = function(scales)
{
	const self = this;

	const createItem = function(obj)
	{
		return jQuery('<a>', {
			href: '#',
			html: obj.label,
			click: function(evt) {
				evt.preventDefault();
				try
				{
					self._doChangeScale(obj.value);
				}
				catch(err)
				{
					gc.gis.iface.log.error(self, err);
				}
				jQuery(this).blur();
			}
		});
	};

	// Liste befüllen
	this._element_ul.empty();
	for(let i=0; i<scales.length; i++)
	{
		this._element_ul.append(jQuery('<li>', {
			html: createItem(scales[i])
		}));
	}
};

/**
 * Liefert den Inhalt des Controls.
 *
 * @public
 * @return {Number} Maßstabszahl
 */
gc.gis.widget.GCScaleSelector.prototype.getScale = function()
{
	return this._currentScale;
};

/**
 * Setzt den Inhalt des Controls.
 *
 * @public
 * @param {Number|String} scale Maßstabszahl
 */
gc.gis.widget.GCScaleSelector.prototype.setScale = function(scale)
{
	if (this._isValid(scale))
	{
		this._currentScale = gc.gis.GCUtil.clamp(this._toNumber(scale), this._minScale, this._maxScale);
	}

	this._element_input.val(this._format(this._currentScale));
	this._setValid(true);   // hier wird immer ein gültiger Eintrag hergestllt
};

/**
 * Aktiviert oder deaktiviert die nutzefreie Nutzereingabe von Maßstäben.
 *
 * @public
 * @param {boolean} enable Flag, ob freie Nutzereigaben für den Maßstab zulässig sind
 */
gc.gis.widget.GCScaleSelector.prototype.enableUserdefinedScale = function(enable)
{
	this._userdefinedScale = enable;
	this._element_input.attr('readonly', !enable);
};

gc.gis.widget.GCScaleSelector.prototype.setScaleBounds = function(min, max)
{
	this._minScale = min > 0 ? min : 1;
	this._maxScale = max || Number.MAX_VALUE;
};

/**
 * Führt die Änderung des Maßstabs aus.
 * @param {String} scale Maßstabszahl gemäß Nutzereingabe
 * @private
 */
gc.gis.widget.GCScaleSelector.prototype._doChangeScale = function (scale)
{
	const oldScale = this._currentScale;
	this.setScale(scale);

	if (oldScale !== this.getScale() && typeof this._change === 'function')
	{
		this._change.call(this, this.getScale());
	}
};

/**
 * Überführt die Maßstabszahl (ggf. mit Trennern etc.) in eine gültige Zahl.
 *
 * @param {String} value
 * @return {Number|null}
 * @private
 */
gc.gis.widget.GCScaleSelector.prototype._toNumber = function(value)
{
	let ret = value.toString().replace('.', '');
	try
	{
		ret = parseInt(ret);
	}
	catch (err)
	{
		ret = null;
	}

	return ret;
};

/**
 * Prüft, ob die angegebene Maßstabszahl gültig ist.
 *
 * @param {String} value
 * @return {boolean}
 * @private
 */
gc.gis.widget.GCScaleSelector.prototype._isValid = function(value)
{
	let ret = false;

	value = value.toString().replace('.', '');
	try
	{
		ret = value === parseInt(value).toString();
	}
	catch (err) {}

	return ret;
};

/**
 * Formatiert die angegebene Maßstabszahl in eine vernünftige lesbare Form.
 *
 * @param {Number} scale
 * @return {string}
 * @private
 */
gc.gis.widget.GCScaleSelector.prototype._format = function(scale)
{
	return scale.toLocaleString();
};

/**
 * Setzt das Eingabeelement in den gültig/ungültig Status.
 *
 * @param {boolean} valid
 * @private
 */
gc.gis.widget.GCScaleSelector.prototype._setValid = function(valid)
{
	if (valid) {
		this.element.removeClass('has-error');
		this._element_drop_btn.removeClass('btn-danger');
	}
	else {
		this.element.addClass('has-error');
		this._element_drop_btn.addClass('btn-danger');
	}
};